import { formatDateForAPI } from '@/features/invitee/utils/inviteeFormatters'

/** Last Saturday (or prior Saturday) — matches Angular `moment().day(moment().day() >= 6 ? 6 : -1)`. */
export function getLastSaturdayDate(): Date {
  const d = new Date()
  const day = d.getDay()
  const diff = day >= 6 ? 0 : -(day + 1)
  const sat = new Date(d)
  sat.setDate(d.getDate() + diff)
  sat.setHours(12, 0, 0, 0)
  return sat
}

export function getRolling52WeekRange(): { fromDt: string; toDt: string } {
  const end = getLastSaturdayDate()
  const start = new Date(end)
  start.setFullYear(start.getFullYear() - 1)
  return {
    fromDt: formatDateForAPI(start),
    toDt: formatDateForAPI(end),
  }
}

export function addOneYearYmd(fromYmd: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(fromYmd)) return fromYmd
  const [y, m, d] = fromYmd.split('-').map(Number)
  const next = new Date(y + 1, m - 1, d, 12, 0, 0, 0)
  return formatDateForAPI(next)
}

export function yearBoundsYmd(year: number): { fromDt: string; toDt: string } {
  return {
    fromDt: `${year}-01-01`,
    toDt: `${year}-12-31`,
  }
}

export function buildYearOptions(count = 5): (number | 'Rolling 52 Weeks')[] {
  const currentYear = new Date().getFullYear()
  const years: (number | 'Rolling 52 Weeks')[] = ['Rolling 52 Weeks']
  for (let i = 0; i < count; i++) years.push(currentYear - i)
  return years
}
